export default "__VITE_ASSET__Cv4GQbAc__"